import React, { useContext } from "react";
import { useHistory } from "react-router";

import { Button, Typography } from "@material-ui/core";
import Box from "@material-ui/core/Box";
import { SelectorContext } from "../../../../contexts/SelectorContext";


export default function TravelCoSelector(){

    const selectorContext = useContext(SelectorContext);
    const history = useHistory();
    if(selectorContext){
        if(selectorContext.hasOptions && selectorContext.unit){

            return (
                <Box className="accountSelector" >
                    <Typography className="selectorLabel" variant="Body2">{selectorContext.unit.companyName}</Typography>
                    <Button
                        className="releaseButton"
                        size="small"
                        sx={{display:'inline'}}
                        variant="outlined"
                        onClick={()=>{
                            selectorContext.releaseUnit();
                            history.push('/');
                        }}
                    >
                        Choose Another
                    </Button>
                </Box>
            );
        }
    }

    return null;

}